import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { AllSiteUsersSpace, AllSiteUsersSpaceDispatchProps, AllSiteUsersSpaceOwnProps, AllSiteUsersSpaceStateProps } from './AllSiteUsersSpace';

const mapStateToProps: MapStateToProps<AllSiteUsersSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
  doesTheServerHaveMoreThanOneSite: SessionServerSelectors.doesTheServerHaveMoreThanOneSite(state),
});

const mapDispatchToProps: MapDispatchToProps<AllSiteUsersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs,
}, dispatch);

export const ConnectedAllSiteUsersSpace: React.ComponentClass<AllSiteUsersSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSiteUsersSpace);
